import { HttpClient, HttpResponseBase } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable, throwError as _observableThrow } from 'rxjs'
import {
    catchError as _observableCatch,
    mergeMap as _observableMergeMap,
} from 'rxjs/operators'

import { OptionsType } from '../utils/handshake.model'
import { BaseService } from '../shared/base.service'
import { MainService } from '../shared/main.service'
import { ConfigService } from './config.service'
import { API, HANDSHAKE } from '../utils/constants'

@Injectable({
    providedIn: 'root',
})
export class EmailService {

    isHandShakeFlg: boolean;
    API_URL: string;

    constructor(
        private http: HttpClient,
        private mainService: MainService,
        private baseService: BaseService,
        private configSevice: ConfigService
    ) {
        this.isHandShakeFlg = this.configSevice.get(HANDSHAKE);
        this.API_URL = this.configSevice.get(API);
    }

    // confirmEmail
    confirmEmail(s: string): Observable<any> {
        let url_ = this.API_URL + 'Email/ConfirmEmail';
        url_ = url_.replace(/[?&]$/, "");

        let func = (endpoint: string, encryptedData: object, opts: OptionsType) => {
            let options_: any = {
                body: encryptedData,
                observe: 'response',
                responseType: 'blob',
                headers: opts.headers,
            }

            return this.http
                .request('post', endpoint, options_)
                .pipe(
                    _observableMergeMap((response: any) => {
                        return this.mainService.processReponse(response)
                    }),
                )
                .pipe(
                    _observableCatch((response: any) => {
                        if (response instanceof HttpResponseBase) {
                            try {
                                return this.mainService.processReponse(<any>response)
                            } catch (e) {
                                return <Observable<any>>(<any>_observableThrow(e))
                            }
                        } else
                            return <Observable<any>>(<any>_observableThrow(response.result))
                    }),
                )
        }

        return this.baseService.handShakeAndCall<any>(
            url_,
            { s: s },
            null,
            func,
            this.isHandShakeFlg,
        )
    }

    // urlNotCorrect
    urlNotCorrect(id: string): Observable<any> {
        return this.http.get<any>(
            this.API_URL + 'Email/UrlNotCorrect?_id=' + id
        )
    }

    // nopeReceiveEmail
    nopeReceiveEmail(id: string): Observable<any> {
        return this.http.get<any>(
            this.API_URL + 'Email/NopeReceiveEmail?_id=' + id
        )
    }

    // receiveEmail
    receiveEmail(id: string): Observable<any> {
        return this.http.get<any>(
            this.API_URL + 'Email/ReceiveEmail?_id=' + id
        )
    }

    // verifyEmail
    verifyEmail(sValue: string, isCaptchaValid: boolean): Observable<any> {
        return this.http.post<any>(
            this.API_URL + 'Email/VerifyEmail',
            { sValue, isCaptchaValid }
        )
    }

    // verifyEmailSuccess
    verifyEmailSuccess(id: string): Observable<any> {
        return this.http.get<any>(
            this.API_URL + 'Email/VerifyEmailSuccess?_id=' + id
        )
    }
}